export default "__VITE_ASSET__x63ehLbl__"